var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line',{attrs:{"x1":_vm._x1,"y1":_vm.y,"x2":_vm._x2,"y2":_vm.y,"stroke":_vm.color,"stroke-width":_vm.height,"stroke-linecap":"round"}})}
var staticRenderFns = []

export { render, staticRenderFns }